export default __webpack_public_path__ + "static/media/gutargu2.15630bd4.png";